export default __webpack_public_path__ + "static/media/tv.a8829060.png";